document.addEventListener('DOMContentLoaded',function(){document.documentElement.classList.add('jmf-enhanced');var spec=document.querySelector('.builder--stage-spec');if(spec&&!document.querySelector('.jmf-builder-help')){var note=document.createElement('p');note.className='jmf-builder-help';note.textContent='Enter your exact dimensions in millimetres. Your price is calculated from the size and options you choose before you add the door to your basket.';spec.parentNode.insertBefore(note,spec)}document.querySelectorAll('.builder--stage-spec input,.builder--stage-spec textarea').forEach(function(f){f.addEventListener('focus',function(){document.body.classList.add('builder-input-active')});f.addEventListener('blur',function(){document.body.classList.remove('builder-input-active')})});document.querySelectorAll('input[name="heightmm"],input[name="widthmm"]').forEach(function(f){f.setAttribute('inputmode','numeric');f.setAttribute('autocomplete','off')})});
(function(){
  var productCache={};
  var timer;
  function money(pence){return new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP'}).format(pence/100)}
  function dimensions(){
    var h=parseInt((document.querySelector('input[name="heightmm"]')||{}).value,10);
    var w=parseInt((document.querySelector('input[name="widthmm"]')||{}).value,10);
    return {height:h,width:w,valid:Number.isFinite(h)&&Number.isFinite(w)&&h>0&&w>0};
  }
  function handle(){return new URLSearchParams(location.search).get('style')||'plain-shaker'}
  async function product(){
    var key=handle();
    if(!productCache[key]){
      var response=await fetch('/products/'+encodeURIComponent(key)+'.js');
      if(!response.ok)throw new Error('Unable to load door prices');
      productCache[key]=await response.json();
    }
    return productCache[key];
  }
  function suitableVariant(variants,d){
    var match=null,excess=Infinity;
    variants.forEach(function(v){
      var size=String(v.title||'').match(/(\d+)x(\d+)/i);
      if(!size)return;
      var vh=parseInt(size[1],10),vw=parseInt(size[2],10);
      var hd=vh-d.height,wd=vw-d.width;
      if(hd>=0&&wd>=0&&hd+wd<excess){match=v;excess=hd+wd}
    });
    return match;
  }
  function extras(d){
    var b=window.builder||{},total=0;
    if(b.hingeButt==='Yes')total+=d.height>=1600?1500:1000;
    if(b.hingeHoles==='Yes'&&b.hinges==='Yes'&&b.hingeOption){
      var count=d.height>=2401?5:d.height>=1901?4:d.height>=901?3:2;
      total+=count*500;
    }
    if(b.hingeCustom==='Yes'&&b.hingeCustomPositions)total+=500;
    return total;
  }
  async function update(){
    var el=document.querySelector('.jmf-live-price-value');
    if(!el)return;
    var d=dimensions();
    var buy=document.querySelector('.buyDoor');
    if(!d.valid){el.textContent='Enter size';el.removeAttribute('data-price-pence');if(buy)buy.classList.add('disabled');return}
    if(buy)buy.classList.remove('disabled')
    window.builder=window.builder||{};
    window.builder.dimensions='Height: '+d.height+', Width: '+d.width;
    el.textContent='Calculating…';
    try{
      var p=await product(),variant=suitableVariant(p.variants||[],d);
      if(!variant){el.textContent='Size unavailable';return}
      var total=Number(variant.price)+extras(d);
      el.textContent=money(total);
      el.dataset.pricePence=String(total);
      el.title='Door price including currently selected options';
    }catch(e){el.textContent='Price unavailable'}
  }
  window.jmfUpdateBuilderPrice=update;
  function schedule(){clearTimeout(timer);timer=setTimeout(update,120)}
  document.addEventListener('DOMContentLoaded',function(){
    if(!document.querySelector('.jmf-live-price'))return;
    document.addEventListener('input',schedule);
    document.addEventListener('change',schedule);
    document.addEventListener('click',function(e){if(e.target.closest('[data-boolean],[data-style],.button'))schedule()});
    schedule();
  });
})();
(function(){
  function trackDoorSelection(link){
    var card=link.closest('.builder-card--one'),title=card&&card.querySelector('.builder-card--one-title,.builder-card--one-content h2,.builder-card--one-content h3');
    var name=(title&&title.textContent||link.getAttribute('data-product-title')||link.textContent||'Door').trim();
    window.dataLayer=window.dataLayer||[];
    window.dataLayer.push({event:'door_selected',door_name:name,destination:link.href||''});
    document.dispatchEvent(new CustomEvent('jmf:analytics',{detail:{event:'door_selected',door_name:name,destination:link.href||''}}));
  }
  document.addEventListener('click',function(e){
    var link=e.target.closest('.builder-card--order-button');
    if(link)trackDoorSelection(link);
  });
})();
